import createFilter from 'redux-persist-transform-filter';

export const appStateFilter = createFilter(
  'appState',
  ['version'],
  ['version'],
);
export const documentsFilter = createFilter(
  'documents',
  ['data', 'lastUpdated'],
  ['data', 'lastUpdated'],
);
export const roadmapFilter = createFilter(
  'roadmap',
  ['data'],
  ['data'],
);



// WEBPACK FOOTER //
// ./book/src/commons/offline/persistStateFilter.js